module.exports = __webpack_public_path__ + "img/slack.950f8546.png";